import React from 'react';
import { Typography, Box, Link } from '@mui/material';

function ValidJobOfferInfo() {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Valid Job Offer
      </Typography>
      <Typography variant="body1" paragraph>
        A valid job offer, especially one supported by a Labour Market Impact Assessment (LMIA), can significantly increase your CRS score. An LMIA is a document from Employment and Social Development Canada (ESDC) that gives the employer permission to hire a foreign worker.
      </Typography>
      <Typography variant="body1" paragraph>
        The number of points awarded for a valid job offer depends on the National Occupational Classification (NOC) TEER category of the job.
      </Typography>
      <Link href="https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/express-entry/documents/offer-employment.html" target="_blank" rel="noopener">
        Learn more about valid job offers
      </Link>
    </Box>
  );
}

export default ValidJobOfferInfo;